const initialState = null;

const getUserRolePermission = (state = initialState, action) => {
  switch (action.type) {
    case "GET_USER_ROLE_PERMISSION":
      return action.payload;
    default:
      return state;
  }
};

export default getUserRolePermission;
